import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type AssetVersionSkeletonProps = ComponentProps<'div'>;

export const AssetVersionSkeleton = memo(({ className, ...restOfProps }: AssetVersionSkeletonProps) => {
  return (
    <div
      className={cn('flex items-center gap-4 rounded-8 ads:bg-base bg-gray-1 p-2', className)}
      data-testid="ASSET_VERSION_SKELETON"
      {...restOfProps}
    />
  );
});

AssetVersionSkeleton.displayName = 'AssetVersionSkeleton';
